import { render, staticRenderFns } from "./complaintRecord.vue?vue&type=template&id=00ad8116&scoped=true&"
import script from "./complaintRecord.vue?vue&type=script&lang=js&"
export * from "./complaintRecord.vue?vue&type=script&lang=js&"
import style0 from "./complaintRecord.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./complaintRecord.vue?vue&type=style&index=1&id=00ad8116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ad8116",
  null
  
)

export default component.exports